import { flutterAssetPaths, FlutterAssetIconName } from "./flutter-assets";
import type { CSSProperties } from "react";
import styles from "./medical-icon.module.css";

type MedicalFallbackIconName =
  | "account"
  | "arrowLeft"
  | "arrowRight"
  | "caretDown"
  | "check"
  | "device"
  | "gender"
  | "inactive"
  | "mail"
  | "memo"
  | "notification"
  | "password"
  | "person"
  | "phone"
  | "scheduled"
  | "search"
  | "test"
  | "x";

export type MedicalIconName = FlutterAssetIconName | MedicalFallbackIconName;

type MedicalIconProps = {
  name: MedicalIconName;
  className?: string;
  renderAsImage?: boolean;
};

const assetIconNames = new Set<MedicalIconName>(Object.keys(flutterAssetPaths.icon) as MedicalIconName[]);

export function MedicalIcon({ className, name, renderAsImage = false }: MedicalIconProps) {
  const iconClassName = [styles.icon, className].filter(Boolean).join(" ");

  if (assetIconNames.has(name)) {
    const iconPath = flutterAssetPaths.icon[name as FlutterAssetIconName];
    const isRasterIcon = /\.(png|jpe?g|webp)$/i.test(iconPath);

    if (isRasterIcon || renderAsImage) {
      return (
        <span className={iconClassName} aria-hidden="true">
          <img className={styles.asset} src={iconPath} alt="" />
        </span>
      );
    }

    return (
      <span className={iconClassName} aria-hidden="true">
        <span
          className={styles.assetMask}
          style={{ "--sat014-icon-url": `url("${iconPath}")` } as CSSProperties}
        />
      </span>
    );
  }

  return (
    <span
      className={[iconClassName, styles[name as MedicalFallbackIconName]].join(" ")}
      aria-hidden="true"
    />
  );
}
